import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBooking = function SvgBooking(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.69 3.586a.95.95 0 1 0-1.9 0v.92H9.21v-.92a.95.95 0 0 0-1.9 0v.92h-.92a2.82 2.82 0 0 0-2.82 2.82V18.544a2.82 2.82 0 0 0 2.82 2.82h11.22a2.82 2.82 0 0 0 2.82-2.82V7.325a2.82 2.82 0 0 0-2.82-2.82h-.92v-.92Zm1.84 6.529v-2.79a.92.92 0 0 0-.92-.92h-.92v.92a.95.95 0 1 1-1.9 0v-.92H9.21v.92a.95.95 0 0 1-1.9 0v-.92h-.92a.92.92 0 0 0-.92.92v2.79h13.06Zm-13.06 1.9h13.06v6.53a.92.92 0 0 1-.92.92H6.39a.92.92 0 0 1-.92-.92v-6.53Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgBooking;